export default __webpack_public_path__ + "static/media/steering.6a9fc609.svg";